import { dynamicJSLoad } from './dynamicJSLoadHelper';

export const loadMathjax = dynamicJSLoad(
  'mathjax-js',
  'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML',
);
